import { convertToStagePoint, getHotkeyMenu, HOTKEY_TYPE, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { ContextMenuPlugin } from '../../../context-menu';
import { ContextMenuPluginDependency } from '../../../dependency';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = (_: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    // ATTENTION: 当前因为还未做系统剪贴板的权限申请机制，因此只有自定义剪贴板变化才有触发事件 */
    const disabled = !framework.getInstance(ContextMenuPluginDependency).getClipboardData()?.template;

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.paste),
        type: HOTKEY_TYPE.paste,
        desc: getHotkeyMenu(HOTKEY_TYPE.paste),
        onClick: () => {
            // ATTENTION: 右键菜单粘贴时，是根据当前点击的位置粘贴
            const scale = framework.stage.getScale();
            const { x, y } = framework.getInstance(ContextMenuPlugin).positionInfo;
            const point = convertToStagePoint(framework.identity, { x, y }, framework.stage.getActiveStageIndex());
            framework.getInstance(ContextMenuPluginDependency).onPaste({
                x: point.x / scale,
                y: point.y / scale,
            });
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 1,
    sort: 6,
    render,
} as IExportContextMenuItem;
